import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { translate } from 'react-polyglot';
import { FormLabel, FormCodeInput, FormFeedback, BaseForm } from '../form';
import { PrimaryButton } from '../buttons';
import { DIARY_PIN_SIZE } from './index';
import './DiaryResetPin.css';

function DiaryResetPin(props) {
  const { showSuccessMessage, showFailureMessage, onSubmit, t } = props;

  return (
    <div>
      <div className="page-header">
        <h1>{t('diaryReset.title')}</h1>
      </div>
      <div className="diary-reset-pin-container container">
        {showSuccessMessage ? (
          <div className="diary-reset-pin-success">
            <h2>{t('diaryReset.successTitle')}</h2>
            <p>{t('diaryReset.successDescription')}</p>
            <NavLink to="/diary">
              <PrimaryButton
                label={t('diaryReset.goToDiary')}
                type="button"
                colorScheme="green"
              />
            </NavLink>
          </div>
        ) : (
          <BaseForm onSubmit={onSubmit}>
            <FormLabel>{t('diaryReset.pin')}</FormLabel>
            <FormCodeInput name="pin" fields={DIARY_PIN_SIZE} type="number" />
            {showFailureMessage && (
              <div className="diary-reset-pin-failure">
                <FormFeedback positive={false}>
                  {t('diaryReset.failure')}
                </FormFeedback>
              </div>
            )}
            <div>
              <PrimaryButton label={t('diaryReset.reset')} type="submit" />
            </div>
          </BaseForm>
        )}
      </div>
    </div>
  );
}

DiaryResetPin.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isButtonDisabled: PropTypes.bool.isRequired,
  showSuccessMessage: PropTypes.bool.isRequired,
  showFailureMessage: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

export default translate()(DiaryResetPin);



// WEBPACK FOOTER //
// ./src/components/diary/DiaryResetPin.js